import { createContext, useContext } from 'react';
import { SelectionType } from '../hooks/useSelectionState';

type SelectionContextValue = {
  isSelected: (columnId: string, type: SelectionType, itemId: number) => boolean;
  toggleSelect: (columnId: string, type: SelectionType, itemId: number) => void;
  removeMany: (items: { columnId: string; type: SelectionType; itemId: number }[]) => void;
  addMany: (items: { columnId: string; type: SelectionType; itemId: number }[]) => void;
  selectionSize: number;
  isMultiDragActive: boolean;
  isDark: boolean;
  /** Mode consultation : drag, sélection et reset désactivés. */
  isReadOnly: boolean;
};

const SelectionContext = createContext<SelectionContextValue>({
  isSelected: () => false,
  toggleSelect: () => undefined,
  removeMany: () => undefined,
  addMany: () => undefined,
  selectionSize: 0,
  isMultiDragActive: false,
  isDark: false,
  isReadOnly: false
});

export const useSelectionContext = () => {
  const context = useContext(SelectionContext);
  if (context === undefined) {
    throw new Error('useSelectionContext must be used with a SelectionContext');
  }
  return context;
};

export const SelectionProvider = SelectionContext.Provider;
